module.exports = __webpack_public_path__ + "static/media/question-mark-button.e598bee8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CareIcons/question-mark-button.svg
// module id = 655
// module chunks = 0